type AnankeLoadingOverlayProps = {
    visible: boolean;
    message?: string;
    zIndex?: number;
    overlayProps?: {
        opacity?: number;
    };
};

export function AnankeLoadingOverlay({
    visible,
    message,
    zIndex,
    overlayProps,
}: AnankeLoadingOverlayProps) {
    if (visible !== true) {
        return null;
    }

    const opacity = overlayProps?.opacity ?? 0.6;

    return (
        <div
            className="absolute inset-0 grid place-items-center bg-[color:var(--ds-surface-overlay,#FFFFFF)] text-[color:var(--ds-text,#172B4D)]"
            style={{zIndex, opacity}}
        >
            <div className="rounded bg-[color:var(--ds-surface,#FFFFFF)] px-ds-space-200 py-ds-space-100 text-sm font-medium shadow">
                {message ?? "Loading..."}
            </div>
        </div>
    );
}
